
				var addMethods = require("../node_modules/workerize-loader/dist/rpc-wrapper.js")
				var methods = ["obfuscate","evaluateCodeSandbox"]
				module.exports = function() {
					var w = new Worker(__webpack_public_path__ + "741310a2b3887352f951.worker.js", { name: "[fullhash].worker.js" })
					URL.revokeObjectURL(__webpack_public_path__ + "741310a2b3887352f951.worker.js");
					addMethods(w, methods)
					
					return w
				}
			